import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, isEmpty, isEqual } from 'lodash';
import { memo } from 'react';
import { useMemo } from 'react';
import _ from 'lodash';
import {
  setEditSelectedMEMRIUser,
  setEditSelectedMRIMarket,
  setEditSelectedPropCode,
} from '../../../../actions/entitlementActions';
import Accordion from '../../Accordion';
import AccordionInnerItem from '../../Accordion/components/AccordionInnerItem';
import AccordionItem from '../../Accordion/components/AccordionItem';
import {
  AVAILABLE_MARKETS,
  GRID_HEADING_AUTO_ADD,
  GRID_HEADING_HISTORICAL,
  GRID_HEADING_PRODUCT,
  GRID_HEADING_REMOVE_OLD,
  GRID_HEADING_SEAT_MAX,
  GRID_HEADING_STUDY,
  GRID_HEADING_SUBSCRIBER,
  MRI_TOP_MARKETS,
  SEARCH_MARKETS,
  SEARCH_MARKETS_PLACHOLDER,
  SELECTED_MARKETS,
  SIMMONS_LOCAL,
  AVAILABLE_MEMRI_USERS,
  SELECTED_MEMRI_USERS,
  HEADER_MEMRI_USERS,
  OPTION_MEMRI_USERS,
  PROP_CODE,
  PROP_HEADER,
  AVAILABLE_PROP_CODE,
  SELECTED_PROP_CODE,
  SEARCH_PROPCODES,
  SEARCH_PROPCODES_PLACEHOLDER,
} from '../../constants';
import MidAccordionInner from '../../MidAccordion/components/MidAccordionInner';
import MidAccordionItem from '../../MidAccordion/components/MidAccordionItem';
import MidAccordion from '../../MidAccordion';
import PropCode from '../../PropCode';
import { useDispatch, useSelector } from '../../../common/react-redux-hooks';
import { mapProdData, mapStudyData } from '../../../../util/ContractAdminUtils';
import {
  getDmaMarkets,
  saveEntitlementMemri,
} from '../../../../actions/entitlementActions';
import PortalModal from '../../../common/Modal/PortalModal';
import MarketPopup from '../../MarketPopup';
import {
  setAutoAdd,
  setAutoRemove,
  setIsAnychildSelected,
  setSelected,
  updateAnychildSelectedValue,
} from '../../../../util/EntitlementUtils';
import RldOnlyModal from '../../MidAccordion/components/RldOnlyModal';

const modalStyles = {
  left: '30%',
  top: '10%',
  width: '835px',
  height: '674px,',
};

const rldModalStyles = {
  left: '30%',
  top: '10%',
  width: '450',
  height: '130,',
};
const d = new Date();
const year = d.getFullYear();
const EntitlementTable = ({
  setSelStudy,
  twoYrBackData,
  contractEnd,
  setSelProd,
  setSelMarket,
  setSelMemri,
  setSelProps,
  setSelMemriDtos,
  setProdChanged,
  setStudyChanged,
  setMarketChanged,
  setMemriChanged,
  setPropCodeChanged,
  reset,
  selectedLoc,
  allLoc,
  setPropChanged,
}) => {
  const dispatch = useDispatch();
  const {
    middleData,
    entStudies,
    isTPPAccountSelected,
    mriTopMarkets,
    memriUsers,
    simmonsLocalMarkets,
    editEntMarkets,
    editEntitlement,
    selectedEntitlementId,
    editEntMemri,
    editSelectedPropCode,
  } = useSelector(state => ({
    middleData: state.contractAdmin.middleData,
    entStudies: state.contractAdmin.entStudies,
    isTPPAccountSelected: state.contractAdmin.isTPPAccountSelected,
    mriTopMarkets: state.contractAdmin.mriTopMarkets,
    memriUsers: state.contractAdmin.memriUsers,
    simmonsLocalMarkets: state.contractAdmin.simmonsLocalMarkets,
    editEntMarkets: state.contractAdmin.editEntMarkets,
    editEntMemri: state.contractAdmin.editEntMemri,
    selectedEntitlementId: state.contractAdmin.selectedEntitlementId,
    editEntitlement: state.contractAdmin.editEntitlement,
    editSelectedPropCode: state.contractAdmin.editSelectedPropCode,
  }));
  const [prodData, setProdData] = useState([]);
  const [studyData, setStudyData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalHeader, setModalHeader] = useState('');
  const [marketLists, setMarketLists] = useState([]);
  const [selectedMarketList, setSelectedMarketList] = useState([]);
  const [mriMarketList, setMriMarketList] = useState([]);
  const [localMarketList, setLocalMarketList] = useState([]);
  const [memriUserList, setMemriUserList] = useState([]);
  const [memris, setMemris] = useState([]);
  const [editProps, setEditProps] = useState([]);
  const [propData, setPropData] = useState([]);
  const [memriData, setMemriData] = useState([]);
  const [mriMarketData, setMRIMarketData] = useState([]);
  const [memriUserDtos, setMemriUserDtos] = useState([]);
  const [allLocation, setAllLocation] = useState([]);
  const [selMemris, setSelMemris] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [memri, setMemri] = useState('');
  const [selectedLabel, setSelectedLabel] = useState('');
  const [availableLabel, setAvailableLabel] = useState('');
  const [selLoc, setSelLoc] = useState([]);
  const [marketList, setMarketList] = useState([]);
  const [copyEditProps, setCopyEditProps] = useState([]);
  const [newPropCode, setNewPropCode] = useState([]);
  const [isModalMessageOpen, setIsModalMessageOpen] = useState(false);
  useEffect(() => {
    const data = cloneDeep(middleData);
    setProdData(data);
  }, [middleData]);
  useEffect(() => {
    const isProdChanged = isEqual(
      mapProdData(prodData || [], isTPPAccountSelected),
      mapProdData(middleData || [], isTPPAccountSelected)
    );
    setProdChanged(isProdChanged);
    // dispatch(setUnsavedChangeFlag(false));
    setSelProd(prodData);
  }, [prodData]);

  useEffect(() => {
    setMemriUserDtos(memriData);
    setMRIMarketData(marketList);
  }, [reset]);

  useEffect(() => {
    const ids = [];
    editSelectedPropCode.map(item => ids.push(item.id));
    const propObj = [{ id: ids }];
    setEditProps(propObj);
    setCopyEditProps(propObj);
    setPropData(cloneDeep(editSelectedPropCode));
    setSelProps([...propObj]);
  }, [editSelectedPropCode, reset]);

  useEffect(() => {
    const filterIds = editEntMarkets.find(item => item.studySource === 2);
    const emptyCheck = isEmpty(filterIds);
    if (emptyCheck === false) {
      if (filterIds.studySource === 2) {
        const result = mriTopMarkets.filter(obj =>
          filterIds.ids.includes(obj.id)
        );
        setMarketList(result);
        setMRIMarketData(result);
      }
    }
  }, [editEntMarkets]);

  useEffect(() => {
    const getSelectedMemris = data => {
      const selMemris = [];
      data.map(loc => {
        if (loc.isSelected === 1) {
          selMemris.push(loc.memriUserId);
        }
        return loc;
      });
      return selMemris;
    };
    const memriUserss = [];
    const selEditMemriUser = getSelectedMemris(editEntMemri);
    const memriUserEnt = {
      ids: selEditMemriUser,
    };
    memriUserss.push(memriUserEnt);
    setSelMemris(memriUserss);
  }, [editEntMemri]);

  useEffect(() => {
    setMriMarketList(cloneDeep(mriTopMarkets));
    setLocalMarketList(cloneDeep(simmonsLocalMarkets));
    setMemriUserList(cloneDeep(memriUsers));
  }, [mriTopMarkets, simmonsLocalMarkets, memriUsers]);
  useEffect(() => {
    setMarkets(cloneDeep(editEntMarkets));
    setMemris(cloneDeep(selMemris));
  }, [editEntMarkets, selMemris]);
  useEffect(() => {
    setSelMarket(markets);
    setMarketChanged(isEqual(editEntMarkets, markets));
  }, [editEntMarkets, markets]);
  useEffect(() => {
    setSelMemri(memris);
    setSelMemriDtos(memriUserDtos);
    setMemriChanged(isEqual(selMemris, memris));
  }, [selMemris, memris, memriUserDtos]);
  useEffect(() => {
    const isStudyChanged = isEqual(
      mapStudyData(studyData || []),
      mapStudyData(entStudies || [])
    );
    setSelStudy(studyData);
    setStudyChanged(isStudyChanged);
  }, [studyData]);
  useEffect(() => {
    const data = cloneDeep(entStudies);
    setStudyData(data);
  }, [entStudies]);

  useEffect(() => {
    if (reset) {
      const pData = cloneDeep(middleData);
      const sData = cloneDeep(entStudies);
      setProdData(pData);
      setStudyData(sData);
      setMarkets(cloneDeep(editEntMarkets));
      setMemris(cloneDeep(selMemris));
      setSelStudy(sData);
      setSelProd(pData);
      setEditProps(copyEditProps);
      setPropChanged(true);
    }
  }, [reset]);
  const setHistoricalData = data => {
    if (data.nodes) {
      data.nodes.map(e => {
        if (e.nodes) {
          e.historicalData =
            e.selected || e.isAnyChildSelected ? data.historicalData : '';
          setHistoricalData(e);
        } else if (e.optionName < year && !twoYrBackData) {
          e.selected = false;
          if (
            year - e.optionName <= data.historicalData &&
            e.optionName < year &&
            data.startYear
          ) {
            if (data.startYear && e.optionName >= data.startYear) {
              e.selected = true;
            }
          } else if (
            year - e.optionName <= data.historicalData &&
            e.optionName < year
          ) {
            e.selected = true;
          }
        } else if (e.optionName < year - 2 && twoYrBackData) {
          e.selected = false;
          if (
            year - 2 - e.optionName <= data.historicalData &&
            e.optionName < year - 1 &&
            data.startYear
          ) {
            if (data.startYear && e.optionName >= data.startYear) {
              e.selected = true;
            }
          } else if (
            year - 2 - e.optionName <= data.historicalData &&
            e.optionName < year - 1
          ) {
            e.selected = true;
          }
        }
        return e;
      });
    }
    const isAnyChildSelected = data.nodes.some(e => e.selected === true);
    data.isAnyChildSelected = false;
    if (!data.selected) {
      data.isAnyChildSelected = isAnyChildSelected;
    }
    updateAnychildSelectedValue(studyData, data);
    studyData.map(e => {
      e.isAnyChildSelected = false;
      e.nodes.map(e1 => {
        if (e1.nodes) {
          const isAnyChildSel = e1.nodes.some(e2 => e2.selected === true);
          const isChildDataSelected = e1.nodes.some(
            e2 => e2.isAnyChildSelected === true
          );
          const isAllChecked = e1.nodes.every(e2 => e2.selected === true);
          e1.selected = isAllChecked;
          e1.isAnyChildSelected =
            isChildDataSelected || (isAnyChildSel && !isAllChecked);
        }
        return e1;
      });
      return e;
    });
    studyData.map(e => {
      setIsAnychildSelected(e);
      return e;
    });
  };

  const findObjectAndUpdate = useMemo(
    () => (data, id, e, value, isYear) => {
      let selectedData = null;
      if (isYear) {
        const selectedDataChild =
          data.nodes.find(element => element.optionName === id) ||
          data.nodes.find(element => element.optionId === id);
        selectedData = selectedDataChild;
        // selectedDataChild[e.target.id] = value;
        if (isYear && e.target.id === 'selected') {
          const selectedDataChild =
            data.nodes.find(element => element.optionName === id) ||
            data.nodes.find(element => element.optionId === id);
          selectedDataChild.selected = value;
          const isAnyChildSelected = data.nodes.some(
            e => e.selected === true || e.isAnyChildSelected
          );
          const isAllChecked = data.nodes.every(e => e.selected === true);
          data.isAnyChildSelected = false;
          data.selected = isAllChecked;
          if (!data.selected) {
            data.isAnyChildSelected = isAnyChildSelected;
          }
          data.autoRemove =
            data.selected || data.isAnyChildSelected ? data.autoRemove : false;
          data.autoAdd =
            data.selected || data.isAnyChildSelected ? data.autoAdd : false;
          data.historicalData =
            data.selected || data.isAnyChildSelected ? data.historicalData : '';
          if (selectedDataChild.nodes) {
            const isAnyChildSelected = selectedDataChild.nodes.some(
              e => e.selected === true
            );
            const isAllChecked = selectedDataChild.nodes.every(
              e => e.selected === true
            );
            selectedDataChild.isAnyChildSelected =
              !selectedDataChild.selected &&
              !isAllChecked &&
              isAnyChildSelected;
          }
          updateAnychildSelectedValue(studyData, data);

          studyData.map(e => {
            e = setIsAnychildSelected(e);
            return e;
          });
          selectedData = selectedDataChild;
        }
      } else {
        const selectedDataChild = data.find(element => element.optionId === id);
        selectedDataChild[e.target.id] = value;
        if (
          e.target.id === 'selected' &&
          !value &&
          selectedDataChild.optionName === 'Local Flex'
        ) {
          if (selectedDataChild.optionName === 'Local Flex') {
            const filteredMarket = markets.filter(
              data => data.studySource !== 1
            );
            setMarkets(filteredMarket);
          }
        }
        if (!selectedDataChild) {
          data.map(item => {
            if (item.nodes) {
              return findObjectAndUpdate(item.nodes, id, e, value);
            }
            return item;
          });
        } else {
          selectedData = selectedDataChild;
          if (e.target.id === 'selected' && value && !twoYrBackData) {
            e.historicalData = '5';
          }
        }
      }
      selectedData[e.target.id] = value;
      if (e.target.id === 'selected') {
        if (selectedData.nodes) {
          const isAnyChildSelected = selectedData.nodes.some(
            e => e.selected === true
          );
          const isAllChecked = selectedData.nodes.every(
            e => e.selected === true
          );
          selectedData.isAnyChildSelected =
            !selectedData.selected && !isAllChecked && isAnyChildSelected;
          selectedData.autoRemove =
            selectedData.selected || selectedData.isAnyChildSelected
              ? e.autoRemove
              : false;
          selectedData.autoAdd =
            selectedData.selected || selectedData.isAnyChildSelected
              ? e.autoAdd
              : false;
          selectedData.historicalData =
            selectedData.selected || selectedData.isAnyChildSelected
              ? e.historicalData
              : '';
        }
        setSelected(selectedData, twoYrBackData);
      } else if (e.target.id === 'historicalData') {
        setHistoricalData(selectedData);
      } else if (e.target.id === 'autoAdd') {
        setAutoAdd(selectedData, twoYrBackData, contractEnd);
      } else if (e.target.id === 'autoRemove') {
        setAutoRemove(selectedData);
      }
      setStudyData([...studyData]);
    },
    [studyData]
  );
  const updateObject = useMemo(
    () => (data, e, value, child) => {
      if (child) {
        findObjectAndUpdate(child, data.optionName, e, value, true);
      } else {
        findObjectAndUpdate(studyData, data.optionId, e, value);
      }
    },
    [studyData]
  );
  const updateChildProdDeliverable = useMemo(
    () => (data, child) => {
      prodData.map(item => {
        if (item.modules) {
          item.modules.map(i1 => {
            if (i1.optionId === data.optionId) {
              if (i1.modules) {
                i1.modules.map(e => {
                  if (e.optionId === child.optionId) {
                    e.selected = child.selected;
                  }
                  return e;
                });
                const isAnyChildSelected =
                  i1.modules && i1.modules.some(e => e.selected === true);
                const isAllChecked =
                  i1.modules && i1.modules.every(e => e.selected === true);
                i1.selected = isAllChecked;
                i1.isAnyChildSelected = !isAllChecked && isAnyChildSelected;
              }
              if (item.modules && item.modules.length) {
                const isAnyChildSelected = item.modules.some(
                  e => e.selected === true || e.isAnyChildSelected
                );
                const isAllChecked = item.modules.every(
                  e => e.selected === true
                );
                item.selected = isAllChecked;
                item.isAnyChildSelected = !isAllChecked && isAnyChildSelected;
              }
            }
            return i1;
          });
        }

        return item;
      });
      setProdData([...prodData]);
    },
    [prodData]
  );
  const isAnyCheckBoxChecked = useMemo(
    () => (data, id, value) => {
      const allModules = prodData.flatMap(
        data => data.optionId !== 4 && data.modules
      );
      const anyModulesSelected = allModules.some(item => item && item.selected);
      prodData.map(item => {
        const { optionId, selected } = item;
        const rldSelected = optionId === 8 && selected;
        const otherFeattureSelected = prodData.some(
          data =>
            data.optionId !== 4 &&
            data.optionId !== 8 &&
            data.optionId !== 7 &&
            data.selected
        );
        if (rldSelected && (otherFeattureSelected || anyModulesSelected)) {
          setIsModalMessageOpen(true);
          value = false;
          propData.map(item => {
            if (item.optionId === id) {
              item.selected = value;
            }
            return item;
          });
        } else {
          if (id) {
            prodData.map(item => {
              if (item.optionId === id) {
                item.selected = value;
                if (
                  !(item.selected || item.isAnyChildSelected) &&
                  item.seatsRequired
                ) {
                  item.maxSeats = '';
                }
                if (item.modules) {
                  item.modules.map(child => {
                    child.selected = item.selected;
                    if (child.modules) {
                      child.modules.map(innerChild => {
                        innerChild.selected = item.selected;
                        return innerChild;
                      });
                    }
                    if (child.modules) {
                      const isAnyChildSelected = child.modules.some(
                        e => e.selected === true || e.isAnyChildSelected
                      );
                      const isAllChecked = child.modules.every(
                        e => e.selected === true
                      );
                      child.isAnyChildSelected =
                        !child.selected && !isAllChecked && isAnyChildSelected;
                    }
                    return child;
                  });
                }
              }

              return item;
            });
          } else if (item.modules) {
            item.modules.map(child => {
              if (child.optionId === data.optionId) {
                child.selected = data.selected;
                if (child.modules) {
                  child.modules.map(innerChild => {
                    innerChild.selected = data.selected;
                    return innerChild;
                  });
                }
                if (child.modules) {
                  const isAnyChildSelected = child.modules.some(
                    e => e.selected === true || e.isAnyChildSelected
                  );
                  const isAllChecked = child.modules.every(
                    e => e.selected === true
                  );
                  child.selected = isAllChecked;
                  child.isAnyChildSelected =
                    !child.selected && !isAllChecked && isAnyChildSelected;
                }
              }

              return child;
            });
          }
          if (item.modules && item.modules.length) {
            const isAnyChildSelected = item.modules.some(
              e => e.selected === true || e.isAnyChildSelected
            );
            const isAllChecked = item.modules.every(e => e.selected === true);
            item.selected = isAllChecked;
            item.isAnyChildSelected =
              !item.selected && !isAllChecked && isAnyChildSelected;
            item.maxSeats =
              item.selected || item.isAnyChildSelected ? item.maxSeats : '';
          }
          return item;
        }
      });

      setProdData([...prodData]);
    },
    [prodData]
  );
  const changeMaxSeats = useMemo(
    () => data => {
      prodData.map(item => {
        if (item.optionId === data.optionId) {
          item.maxSeats = data.maxSeats || '';
          return item;
        }
        // return item;
      });
      setProdData([...prodData]);
    },
    [prodData]
  );
  useEffect(() => {
    const setSelectedSate = () => {
      setSelLoc(selectedLoc);
    };
    setSelectedSate();
  }, [selectedLoc, isModalOpen]);

  useEffect(() => {
    const setSelectedSate = () => {
      setAllLocation(allLoc);
    };
    setSelectedSate();
  }, [allLoc, isModalOpen]);
  const getSelectedLocation = data => {
    const request = [];
    data.map(loc => {
      request.push(loc.locationId);
      return loc;
    });
    return request;
  };
  const openMarketPopup = useMemo(
    () => data => {
      if (data.optionName === 'MEMRI-USERS') {
        const selLocations = getSelectedLocation(selLoc);
        const allLocations = getSelectedLocation(allLocation);
        const data = {
          entitlementId: editEntitlement ? selectedEntitlementId : null,
          locationIds: selLocations != '' ? selLocations : allLocations,
        };

        dispatch(saveEntitlementMemri(data)).then(res => {
          const resMemri = cloneDeep(res.data.data);
          setMarketLists(resMemri);

          const marketsLst =
            memris.length && memris.find(el => el.ids)
              ? memris.find(el => el).ids
              : [];
          const selectedMarket = memris.length
            ? resMemri.filter(obj => marketsLst.includes(obj.memriUserId))
            : [];
          setSelectedMarketList(selectedMarket);

          setMemri(OPTION_MEMRI_USERS);
          setModalHeader(HEADER_MEMRI_USERS);
          setSelectedLabel(SELECTED_MEMRI_USERS);
          setAvailableLabel(AVAILABLE_MEMRI_USERS);
          setIsModalOpen(true);
        });
      } else if (data.optionName === 'PROP-CODE') {
        const propCodes = cloneDeep(data.availablePropCodes);
        setMarketLists(propCodes);
        setPropChanged(true);

        const props = newPropCode.length ? copyEditProps : editProps;
        const marketsLst =
          props.length && props.find(el => el.id)
            ? props.find(el => el).id
            : [];

        const selectedMarket = props.length
          ? propCodes.filter(obj => marketsLst.includes(obj.id))
          : [];
        setSelectedMarketList(selectedMarket);
        setMemri(PROP_CODE);
        setModalHeader(PROP_HEADER);
        setSelectedLabel(SELECTED_PROP_CODE);
        setAvailableLabel(AVAILABLE_PROP_CODE);
        setIsModalOpen(true);
      } else if (
        !mriMarketList.length ||
        (!localMarketList.length && data.optionName !== 'MEMRI-USERS')
      ) {
        dispatch(getDmaMarkets()).then(res => {
          const localMarket = cloneDeep(res.localMarkets);
          const mriMarkets = cloneDeep(res.topMarkets);
          if (data.optionName === 'Local Flex') {
            setMemri('');
            setSelectedLabel(SELECTED_MARKETS);
            setAvailableLabel(AVAILABLE_MARKETS);
            const marketsLst =
              markets.length &&
              markets.find(el => el.studySource === localMarket[0].studySource)
                ? markets.find(
                    el => el.studySource === localMarket[0].studySource
                  ).ids
                : [];
            const selectedMarket = markets.length
              ? localMarket.filter(obj => marketsLst.includes(obj.id))
              : [];
            setSelectedMarketList(selectedMarket);
            setMarketLists(localMarket);
            setModalHeader(SIMMONS_LOCAL);
          } else {
            setMemri('');
            setSelectedLabel(SELECTED_MARKETS);
            setAvailableLabel(AVAILABLE_MARKETS);

            const marketsLst =
              markets.length &&
              markets.find(el => el.studySource === mriMarkets[0].studySource)
                ? markets.find(
                    el => el.studySource === mriMarkets[0].studySource
                  ).ids
                : [];
            const selectedMarket = markets.length
              ? mriMarkets.filter(obj => marketsLst.includes(obj.id))
              : [];
            setSelectedMarketList(selectedMarket);
            setMarketLists(mriMarkets);
            setModalHeader(MRI_TOP_MARKETS);
          }
          setIsModalOpen(true);
        });
      } else {
        if (data.optionName === 'MEMRI-USERS') {
          setMarketLists(memriUserList);
          setMemri(OPTION_MEMRI_USERS);
          setSelectedLabel(SELECTED_MEMRI_USERS);
          setAvailableLabel(AVAILABLE_MEMRI_USERS);
          setSelectedMarketList([]);
          setModalHeader(HEADER_MEMRI_USERS);
        } else if (data.optionName === 'Local Flex') {
          setMarketLists(localMarketList);
          setMemri('');
          setSelectedLabel(SELECTED_MARKETS);
          setAvailableLabel(AVAILABLE_MARKETS);

          const marketsLst =
            markets.length &&
            markets.find(
              el => el.studySource === localMarketList[0].studySource
            )
              ? markets.find(
                  el => el.studySource === localMarketList[0].studySource
                ).ids
              : [];
          const selectedMarket = markets.length
            ? localMarketList.filter(obj => marketsLst.includes(obj.id))
            : [];
          setSelectedMarketList(selectedMarket);
          setModalHeader(SIMMONS_LOCAL);
        } else {
          const mriMarkets = mriTopMarkets;
          setMarketLists(mriMarkets);
          setMemri('');
          setSelectedLabel(SELECTED_MARKETS);
          setAvailableLabel(AVAILABLE_MARKETS);
          const marketsLst =
            markets.length &&
            markets.find(el => el.studySource === mriMarkets[0].studySource)
              ? markets.find(el => el.studySource === mriMarkets[0].studySource)
                  .ids
              : [];
          const selectedMarket = markets.length
            ? mriMarkets.filter(obj => marketsLst.includes(obj.id))
            : [];
          setSelectedMarketList(selectedMarket);
          setModalHeader(MRI_TOP_MARKETS);
        }
        setIsModalOpen(true);
      }
    },
    [isModalOpen, markets, selLoc, allLocation]
  );
  const closeModal = () => {
    setIsModalOpen(false);
    setIsModalMessageOpen(false);
  };
  const onContinueClicked = boolean => {
    setIsModalMessageOpen(boolean);
  };
  useEffect(() => {
    if (!memriUserDtos.length) {
      const filteredEditMemri = editEntMemri.filter(memri => memri.isSelected);
      setMemriUserDtos(filteredEditMemri);
      setMemriData(filteredEditMemri);
    }
  }, [editEntMemri]);

  const updateSelectedItems = useMemo(
    () => items => {
      if (modalHeader === 'MEMRI Users') {
        const memriUserSel = items;

        const getSelectedMemriDtos = data => {
          const memriDtos = [];
          data.map(loc => {
            const memrisDto = {};
            memrisDto.memriUserId = loc.memriUserId;
            memrisDto.memriUser = loc.memriUser;
            memrisDto.locationId = loc.locationId;
            memrisDto.isSelected = 1;
            memrisDto.displayMemriUser = loc.displayMemriUser;
            memriDtos.push(memrisDto);
            return loc;
          });
          return memriDtos;
        };

        const memriUserDtos = getSelectedMemriDtos(memriUserSel);
        setMemriUserDtos(memriUserDtos);
        const memriUsers = [...memris];
        const marketList = [];
        items.map(data => marketList.push(data.memriUserId));
        const memriObj = {
          ids: marketList,
        };
        const isExist =
          memriUsers.length &&
          memriUsers.find(data => {
            return data;
          });
        if (memriUsers.length && isExist) {
          memriUsers.find((data, i) => {
            memriUsers[i] = memriObj;
            return data;
          });
          setMemris([...memriUsers]);
          dispatch(setEditSelectedMEMRIUser([...items]));
        } else {
          memriUsers.push(memriObj);
          setMemris([...memriUsers]);
          dispatch(setEditSelectedMEMRIUser([...items]));
        }
        setIsModalOpen(false);
      } else if (modalHeader === 'Prop Codes') {
        const propUsers = [...editProps];
        const marketList = [];
        items.map(data => marketList.push(data.id));
        const propObj = {
          id: marketList,
        };
        const isExist =
          propUsers.length &&
          propUsers.find(data => {
            return data;
          });
        if (propUsers.length && isExist) {
          propUsers.find((data, i) => {
            propUsers[i] = propObj;
            return data;
          });
          setEditProps([...propUsers]);
          setSelProps([...propUsers]);
          setPropData(items);
        } else {
          propUsers.push(propObj);
          setEditProps([...propUsers]);
          setSelProps([...propUsers]);
          setPropData(items);
        }
        const check = isEqual(editProps, propUsers);
        const propCompare = isEqual(editProps, copyEditProps);
        if (!propCompare) setPropChanged(true);
        if (!check) setPropChanged(false);
        setIsModalOpen(false);
      } else {
        const dmaMarkets = [...markets];
        const marketList = [];
        items.map(data => marketList.push(data.id));
        const studySource = !isEmpty(items) && items[0].studySource;
        const marketObj = {
          studySource: studySource ? studySource : marketLists[0].studySource,
          ids: marketList,
        };
        const isExist =
          dmaMarkets.length &&
          dmaMarkets.find(data => {
            return data.studySource === marketObj.studySource;
          });
        if (dmaMarkets.length && isExist) {
          dmaMarkets.find((data, i) => {
            if (data.studySource === marketObj.studySource) {
              dmaMarkets[i] = marketObj;
              return data;
            }
          });
          setMarkets([...dmaMarkets]);
          if (modalHeader === MRI_TOP_MARKETS) setMRIMarketData(items);
          dispatch(setEditSelectedMRIMarket([...items]));
        } else {
          dmaMarkets.push(marketObj);
          setMarkets([...dmaMarkets]);
          if (modalHeader === MRI_TOP_MARKETS) setMRIMarketData(items);
          dispatch(setEditSelectedMRIMarket([...items]));
        }
        setIsModalOpen(false);
      }
    },
    [markets, memris, marketLists, selMemris, modalHeader]
  );
  return (
    <div className="ent-table" data-test="EntitlementTable">
      {isModalOpen && (
        <PortalModal
          title={modalHeader}
          isShowing={isModalOpen}
          dialogStyles={modalStyles}
          onCloseClicked={closeModal}
        >
          <div>
            <MarketPopup
              optionName={memri}
              modalHeader={modalHeader}
              updateSelectedItems={updateSelectedItems}
              selectedMarketList={selectedMarketList}
              closeModal={closeModal}
              options={marketLists}
              searchLabel={
                memri === 'PROP-CODE' ? SEARCH_PROPCODES : SEARCH_MARKETS
              }
              availableListLabel={availableLabel}
              selectedListLabel={selectedLabel}
              searchPlaceHolder={
                memri === 'PROP-CODE'
                  ? SEARCH_PROPCODES_PLACEHOLDER
                  : SEARCH_MARKETS_PLACHOLDER
              }
            />
          </div>
        </PortalModal>
      )}
      <div className="ent-table-left">
        <div className="ent-table-header">
          <div className="ent-table-header-study">{GRID_HEADING_STUDY}</div>
          <div className="ent-table-header-history">
            {GRID_HEADING_HISTORICAL}
          </div>
          <div className="ent-table-header-auto">{GRID_HEADING_AUTO_ADD}</div>
          <div className="ent-table-header-old">{GRID_HEADING_REMOVE_OLD}</div>
        </div>
        <div className="ent-table-left-content">
          {studyData &&
            studyData.map(item => (
              <Accordion
                key={item.optionId}
                hasChild={!!(item.nodes && item.nodes.length)}
                mainContent={
                  <AccordionItem
                    data={item}
                    findObjectAndUpdate={updateObject}
                    openMarketPopup={openMarketPopup}
                    markets={markets}
                  />
                }
                data={item}
                innerChild={
                  <AccordionInnerItem
                    data={item}
                    twoYrBackData={twoYrBackData}
                    findObjectAndUpdate={updateObject}
                    contractEnd={contractEnd}
                  />
                }
              />
            ))}
        </div>
      </div>
      {/** start of middle section which has Product Devliverable */}
      <div className="ent-table-middle">
        <div className="ent-table-header">
          <div className="ent-table-header-product">{GRID_HEADING_PRODUCT}</div>
          <div className="ent-table-header-seat">{GRID_HEADING_SEAT_MAX}</div>
        </div>
        <div className="ent-table-middle-content">
          {prodData &&
            prodData.map(item => (
              <MidAccordion
                key={item.optionId}
                hasChild={!!(item.modules && item.modules.length)}
                isDisable={
                  item.disable && item.optionName !== 'Third Party Provider'
                }
                data={item}
                mainContent={
                  <MidAccordionItem
                    data={item}
                    changeInput={isAnyCheckBoxChecked}
                    changeMaxSeats={changeMaxSeats}
                  />
                }
                innerChild={
                  <MidAccordionInner
                    data={item}
                    isAnyCheckBoxChecked={isAnyCheckBoxChecked}
                    updateChildProdDeliverable={updateChildProdDeliverable}
                    propData={prodData}
                    setIsModalMessageOpen={setIsModalMessageOpen}
                  />
                }
              />
            ))}
          {isModalMessageOpen && (
            <PortalModal
              title={'Incorrect Selection'}
              isShowing={isModalMessageOpen}
              dialogStyles={rldModalStyles}
              onCloseClicked={closeModal}
            >
              <RldOnlyModal onContinueClicked={onContinueClicked} />
            </PortalModal>
          )}
        </div>
      </div>
      {/** end of middle section which has Product Devliverable */}
      <div className="ent-table-right">
        <div className="ent-table-header">
          <div>{GRID_HEADING_SUBSCRIBER}</div>
        </div>
        <div className="ent-table-middle-content">
          <PropCode
            reset={reset}
            openMarketPopup={openMarketPopup}
            markets={markets}
            memris={memris}
            setSelProps={setSelProps}
            setPropCodeChanged={setPropCodeChanged}
            memriUserDtos={memriUserDtos}
            marketList={marketList}
            selectedMarketList={selectedMarketList}
            setEditProps={setEditProps}
            setPropChanged={setPropChanged}
            propData={propData}
            memriData={memriData}
            mriMarketData={mriMarketData}
            editProps={editProps}
            setNewPropCode={setNewPropCode}
          />
        </div>
      </div>
    </div>
  );
};
EntitlementTable.propTypes = {
  setSelStudy: PropTypes.func,
  setSelProd: PropTypes.func,
  selectedLoc: PropTypes.array,
  allLoc: PropTypes.array,
  setSelMarket: PropTypes.func,
  setSelMemri: PropTypes.func,
  setSelMemriDtos: PropTypes.func,
  setSelProps: PropTypes.func,
  setProdChanged: PropTypes.func,
  setStudyChanged: PropTypes.func,
  setMarketChanged: PropTypes.func,
  setMemriChanged: PropTypes.func,
  setPropCodeChanged: PropTypes.func,
  reset: PropTypes.bool,
  twoYrBackData: PropTypes.bool,
  contractEnd: PropTypes.string,
  setPropChanged: PropTypes.func,
};

export default memo(EntitlementTable);
